<img class="image" [src]="imgUrl" [class.image--visible]="logoVisible()" alt="Logo">
